import { render, staticRenderFns } from "./taxBreak.vue?vue&type=template&id=13c9afaa&scoped=true&"
import script from "./taxBreak.vue?vue&type=script&lang=js&"
export * from "./taxBreak.vue?vue&type=script&lang=js&"
import style0 from "./taxBreak.vue?vue&type=style&index=0&id=13c9afaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9afaa",
  null
  
)

export default component.exports